import { render, staticRenderFns } from "./TabsComponent.vue?vue&type=template&id=7578a504&"
import script from "./TabsComponent.vue?vue&type=script&lang=ts&"
export * from "./TabsComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7578a504')) {
      api.createRecord('7578a504', component.options)
    } else {
      api.reload('7578a504', component.options)
    }
    module.hot.accept("./TabsComponent.vue?vue&type=template&id=7578a504&", function () {
      api.rerender('7578a504', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Table/TabsComponent.vue"
export default component.exports